module.exports = __webpack_public_path__ + "static/media/toyota-thumbs.969ff83d.svg";